export default function GATrakingId() {
  const hostName = window.location.hostname;
  if (hostName === "markabte.com") {
    return "UA-222270877-1";
  } else {
    return "UA-199366562-1";
  }
}
